import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import iconoApp from './assets/icono.png';

export default function TechAccessScreen() {
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAccess = async (e) => {
    e.preventDefault();
    if (!pin.trim()) {
      setError('Please enter a PIN');
      return;
    }
    if (!/^[A-Z]{2}[0-9]{4}$/i.test(pin.trim())) {
      setError('Invalid PIN format. Use 2 letters + 4 numbers (e.g. LE4966).');
      return;
    }

    setLoading(true);
    setError('');

    const { data, error: dbError } = await supabase
      .from('proyectos')
      .select('slug')
      .eq('pin', pin.toUpperCase())
      .single();

    if (dbError || !data) {
      setError('PIN not found. Please check and try again.');
      setLoading(false);
      return;
    }

    navigate(`/parque/${data.slug}`, { state: { techValidated: true, pin: pin.toUpperCase() } });
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f4f2ed',
      padding: '20px'
    }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #d4d0c8',
        borderRadius: '12px',
        padding: '40px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img
            src={iconoApp}
            alt="logo"
            style={{ width: '48px', marginBottom: '12px' }}
          />
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1c1e' }}>
            Wind<span style={{ color: '#c96a10' }}>Manager</span> Pro
          </div>
          <div style={{ color: '#7a7a72', fontSize: '0.85rem', marginTop: '8px' }}>
            Technician Access
          </div>
          <div style={{ color: '#9a9a90', fontSize: '0.8rem', marginTop: '12px' }}>
            Enter the PIN provided by your manager
          </div>
        </div>

        <form onSubmit={handleAccess}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              color: '#4a4a44',
              fontSize: '0.75rem',
              fontWeight: 700,
              marginBottom: '6px',
              textTransform: 'uppercase'
            }}>
              PIN
            </label>
            <input
              type="text"
              value={pin}
              onChange={(e) => {
                setPin(e.target.value.toUpperCase());
                setError('');
              }}
              placeholder="e.g. LE4966"
              maxLength={6}
              autoCapitalize="characters"
              autoComplete="off"
              style={{
                textTransform: 'uppercase',
                width: '100%',
                padding: '10px 12px',
                background: '#f4f2ed',
                border: '1px solid #bbb8b0',
                borderRadius: '6px',
                color: '#1a1c1e',
                fontSize: '0.9rem',
                boxSizing: 'border-box',
                fontFamily: "'Barlow', sans-serif"
              }}
            />
          </div>

          {error && (
            <div style={{
              color: '#c0392b',
              fontSize: '0.85rem',
              marginBottom: '16px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: '#3d7a2e',
              border: 'none',
              borderRadius: '6px',
              color: '#fff',
              fontSize: '0.95rem',
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: "'Barlow', sans-serif",
              opacity: loading ? 0.6 : 1
            }}
          >
            {loading ? 'Accessing...' : 'Access Wind Farm'}
          </button>
        </form>

        <button
          onClick={() => navigate('/')}
          style={{
            width: '100%',
            marginTop: '16px',
            padding: '10px',
            background: 'transparent',
            border: '1px solid #d4d0c8',
            borderRadius: '6px',
            color: '#7a7a72',
            fontSize: '0.85rem',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: "'Barlow', sans-serif"
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
}
